import { getLocalizedRoutes } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types/app';
import type { AppRoute } from 'src/types/routes';

import * as id from '../constants/pageUid';
import * as path from '../constants/routes';

export const routes: AppRoute[] = [
  {
    name: id.PAGE_ID_CREATE,
    route: path.ROUTE_CREATE,
    flow: 'create',
    isRoot: true,
  },
  { name: id.PAGE_ID_CLASSIFY, route: path.ROUTE_CLASSIFY, flow: 'create' },
  { name: id.PAGE_ID_CONCIERGE, route: path.ROUTE_CONCIERGE, flow: 'create' },
  {
    name: id.PAGE_ID_GUARANTEED_HIRE,
    route: path.ROUTE_GUARANTEED_HIRE,
    flow: 'create',
  },
  {
    name: id.PAGE_ID_PREMIUM_PLUS,
    route: path.ROUTE_PREMIUM_PLUS,
    flow: 'create',
  },
  { name: id.PAGE_ID_MANAGE, route: path.ROUTE_MANAGE, flow: 'create' },
  {
    name: id.PAGE_ID_PAY_AND_POST,
    route: path.ROUTE_PAY_AND_POST,
    flow: 'create',
  },
  {
    name: id.PAGE_ID_SELECT_AD_TYPE,
    route: path.ROUTE_SELECT_AD_TYPE,
    flow: 'create',
  },
  { name: id.PAGE_ID_SUCCESS, route: path.ROUTE_SUCCESS, flow: 'create' },
  { name: id.PAGE_ID_WRITE, route: path.ROUTE_WRITE, flow: 'create' },
  { name: id.PAGE_ID_EDIT, route: path.ROUTE_EDIT, flow: 'edit', isRoot: true },
  {
    name: id.PAGE_ID_EDIT_PAY_AND_POST,
    route: path.ROUTE_EDIT_PAY_AND_POST,
    flow: 'edit',
  },
  {
    name: id.PAGE_ID_EDIT_SUCCESS,
    route: path.ROUTE_EDIT_SUCCESS,
    flow: 'edit',
  },
  {
    name: id.PAGE_ID_REFRESH,
    route: path.ROUTE_REFRESH,
    flow: 'refresh',
    isRoot: true,
  },
  {
    name: id.PAGE_ID_REFRESH_SUCCESS,
    route: path.ROUTE_REFRESH_SUCCESS,
    flow: 'refresh',
  },
  {
    name: id.PAGE_ID_REFRESH_ERROR,
    route: path.ROUTE_REFRESH_ERROR,
    flow: 'refresh',
  },
  {
    name: id.PAGE_ID_TEST_PAGE,
    route: path.ROUTE_TEST_PAGE,
    flow: null,
  },
  {
    name: id.PAGE_ID_MULTI_LOCATION,
    route: path.ROUTE_MULTI_LOCATION,
    flow: 'multiLocation',
    isRoot: true,
  },
];

export type RouteName = (typeof routes)[number]['name'];

const getRoutesByFlow = (flow: string) =>
  routes.filter((route) => route.flow === flow);

export const getLocalisedRootRoutes = (site: EmployerSiteName) => {
  const rootRoutes = routes.filter((route) => route.isRoot);

  const localiseRootRoutes = getLocalizedRoutes(rootRoutes);
  return localiseRootRoutes(site);
};

export const getLocalisedFlowRoutes = (
  site: EmployerSiteName,
  flow: string,
) => {
  const flowRoutes = getRoutesByFlow(flow);
  const localiseContainerRoutes = getLocalizedRoutes(flowRoutes);
  return localiseContainerRoutes(site);
};
